import Resource from '@/api/Resource';

class TestQuestionAnswer extends Resource {
  $name = 'answers';

  $defaults() {
    return {
      id: null,
      test_question_id: null,
      title: '',
      image: null,
      is_true: 0,
    };
  }

  $save() {
    const data = this.$isNew ? this.$getData() : this.$getData(true);

    if (data.image) {
      data.image_path = data.image;

      delete data.image;
    }

    if (this.$isNew) {
      return this.$api('create', data);
    } else {
      return this.$api('update', this.id, data);
    }
  }
}

export default TestQuestionAnswer;
